import { createFileRoute, redirect } from "@tanstack/react-router";

// Lake Forest schedule page removed — permanently redirect to the Oak Brook schedule page.
export const Route = createFileRoute("/schedule-a-consult/lake-forest")({
  beforeLoad: () => {
    throw redirect({
      href: "/schedule-a-consult/oak-brook/",
      statusCode: 301,
    });
  },
});
